import { Container, Box, Typography, Grid, Divider } from "@mui/material";
import CardFlip from "./CardFlip";

import SportsImage from './../../assets/images/sports_game.png';

const Sports = () => {
    return (
        <Container>
            <Box width={`100%`} className="card-header-bg">
                <Typography display={`flex`} justifyContent={`center`} fontSize={24} color={`white`} py={1}>
                    พนันกีฬา เเทงบอล
                </Typography>
            </Box>
            <Box sx={
                {
                    backgroundColor: 'rgba(0, 0, 0, 0.309)',
                    textAlign: 'center'
                }
            }>
                <Grid container>
                    <Grid item xs={12} py={2}>
                        <Typography fontSize={20} color={`white`}>
                            พนันฟุตบอลออนไลน์ (Football Online)
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Box className="line"></Box>
                    </Grid>
                    <Grid item xs={12} my={2}>
                        <Typography fontSize={19} color={`white`} lineHeight={1} px={1}>
                            พนันฟุตบอลออนไลน์ (Football Online) เดิมพันฟุตบอลที่เหล่าเซียนพนันต้องเป็นที่รู้จักดี และเหล่าเซียนพนันที่ชื่อชอบในกีฬาฟุตบอลคุ้นเคยกันดี พนันฟุตบอลได้รับความนิยมเป็นอย่างมาก โดยรูปแบบการเดิมพันแบบเดิมจะเป็นการเดิมพันได้ตามที่โต๊ะเดิมพันบอลในระแวกต่างๆที่มีผู้บริการเดิมพันฟุตบอลให้บริการ โดยจะมีการเดิมพันโดยกาในบิลของโต๊ะบอลนั้นๆ แต่ปัจจุบันการพนันฟุตบอลได้เปลี่ยนรูปแบบใหม่เป็นการเดิมพันผ่านเว็บคาสิโนออนไลน์แล้ว โดยรูปแบบการเล่นจะเล่นผ่านหน้าเว็บคาสิโนโดยจะมีรูปแบบการแทงทั้ง บอลสเต็ป บอลเดี่ยว บอลคู่ บอลสด การพนันฟุตบอลในรูปแบบใหม่จะเพิ่มความสะดวกสบายในการเดิมพันมากขึ้น โดยท่านจะไม่ต้องเสียเวลาไปเดิมพันที่โต๊ะบอลอีกต่อไป เพียงเข้าแทงผ่านเว็บพนันออนไลน์ที่บ้านก็สามารถเข้าเดิมพันได้แล้ว และการเดิมพันฟุตบอลออนไลน์ก็ยังมีราคาน้ำที่สูงกว่าอีกด้วย
                        </Typography>
                    </Grid>
                    <Grid item xs={12} mb={2}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        <Box px={5}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <CardFlip image={SportsImage} />
                            </Grid>
                        </Box>
                    </Grid>
                    <Grid item xs={12} pt={2} pb={2}>
                        <Box className="line"></Box>
                    </Grid>
                    <Grid item xs={12} mt={2} mb={4}>
                        <Typography fontSize={19} color={`white`} lineHeight={1} px={3}>
                            พนันฟุตบอลได้เงินจริง กับเว็บเรา BETWON พนันฟุตบอลได้อย่างง่ายๆไม่ยากเพียงเล่นกับทางเว็บของเรา เว็บคาสิโนออนไลน์ของเราให้บริการเดิมพันฟุตบอลทุกลีค ทุกแมทย์ดังทั่วโลก ไม่ว่าคู่ไหนๆมีให้ท่านได้เลือกเดิมพันหมด อีกทั้งยังมีอัตราการจ่ายที่สูงกว่าเว็บอื่นๆ ค่าน้ำสูง เดิมพันชนะสามารถแจงถอนได้ทันที ท่านสามารถแจงถอนได้ผ่านหน้าเว็บของเราได้เลย ด้วยระบบฝาก-ถอนที่เร็วที่สุดในโลก ไม่ต้องรอนาน เว็บคาสิโนออนไลน์ของเรามีระบบการเงินดีเยี่ยม 100% ไม่มีโกงแน่นอน เล่นพนันฟุตบอลได้เงินจริง ต้องที่นี่เท่านั้น
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    )
}

export default Sports;